import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./Additional";
// Requests
import { getLiquidityManagementTable } from "src/Requests/imePortfolio";
// Types
import {
  ILiquidityManagementSearchParams,
  ILiquidityManagementTableReport,
} from "src/Interfaces/imePortfolio";

interface IProps {
  searchParams: ILiquidityManagementSearchParams;
  refreshFlag: boolean;
}

const LiquidityManagementTable: React.FC<IProps> = ({
  searchParams,
  refreshFlag,
}) => {
  return (
    <div className="w-full">
      <TableTemplate<
        ILiquidityManagementSearchParams,
        ILiquidityManagementTableReport
      >
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            AdditionalBody={Additional}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={refreshFlag}
            tableBoxClassName="max-h-[700px] overflow-auto"
            withSelect
          />
        )}
        getDataTable={getLiquidityManagementTable}
        searchParameters={searchParams}
        withSort
      />
    </div>
  );
};

export default LiquidityManagementTable;
